import {
  loadDefaultFormData,
} from 'containers/Form/actions'
import {
  UPDATE_REDIRECT,
  CLEAR_PROJECT_INFO_DETAILS,
  UPDATE_PROJECT_INFO_ID,
  UPDATE_PROJECT_INFO_WORKFLOW_ID,
  UPDATE_PROJECT_INFO_DETAILS,
  INITIALIZE_PROJECT,
} from './constants'
import { asyncReduxFilter } from 'containers/Async/actions'
import {
  getProjectDetails,
  createProject,
  getProjectFormUrl,
} from 'containers/Project/actions'
import {
  onSave
} from 'containers/Project/OverviewSidebar/actions'
import {
  updateProjectScheduleChange
} from 'containers/Project/ScheduleSection/actions'

const updateProjectInfoId = (projectId) => {
  return {
    type: UPDATE_PROJECT_INFO_ID,
    projectId
  }
}

const updateProjectInfoWorkflowId = (workflowId) => {
  return {
    type: UPDATE_PROJECT_INFO_WORKFLOW_ID,
    workflowId
  }
}

const updateProjectInfoDetails = (attributes) => {
  return {
    type: UPDATE_PROJECT_INFO_DETAILS,
    ...attributes
  }
}

const clearProjectInfoDetails = () => {
  return {
    type: CLEAR_PROJECT_INFO_DETAILS
  }
}

/**
 * getProjectInfoAction
 * Retrieves project details
 *
 * @param productHierarchyId
 * @param partnerSiteId
 * @returns {undefined}
 */
const getProjectInfoAction = (projectId) => {
  return dispatch => {
    return dispatch(getProjectDetails(projectId))
      .then(({data}) => {
        const {
          attributes,
          id,
        } = data
        dispatch(updateProjectInfoDetails(attributes))
        dispatch(updateProjectInfoWorkflowId(attributes.workflowId))
        dispatch(updateProjectInfoId(id))
        return projectId
      })
  }
}

const createProjectAction = (productHierarchyId, partnerSiteId, productClassTypeId, scheduleInfo) => {
  return dispatch => {
    dispatch(updateProjectScheduleChange(scheduleInfo))
    return dispatch(createProject(productHierarchyId, partnerSiteId, productClassTypeId))
      .then(({data}) => {
        const {
          workflowId,
          projectId,
        } = data.attributes
        dispatch(updateProjectInfoWorkflowId(workflowId))
        dispatch(updateProjectInfoId(projectId))
        return projectId
      })
  }
}

const updateRedirect = redirect => ({ type: UPDATE_REDIRECT, redirect })
const clearRedirect = () => updateRedirect(false)

export {
  updateRedirect,
  clearRedirect,
  clearProjectInfoDetails,
  getProjectInfoAction,
  onSave,
  createProjectAction,
  updateProjectInfoId,
  updateProjectInfoWorkflowId,
}
